
import { AmmunitionStockEventEntityDecoratorBase } from './ammunition-stock-event.decorator.base';


export class AmmunitionStockEventEntityDecorator extends AmmunitionStockEventEntityDecoratorBase {
  constructor() {
    super();
  }
}



